import { Stack, IconButton } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";

interface DataGridActionsCellProps {
  onEdit: () => void;
  onDelete: () => void;
}

export function DataGridActionsCell({
  onEdit,
  onDelete,
}: DataGridActionsCellProps) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{
        alignItems: "center",
        height: "100%",
      }}
    >
      <IconButton size="small" onClick={onEdit}>
        <EditIcon fontSize="small" />
      </IconButton>
      <IconButton size="small" color="error" onClick={onDelete}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}
